module.exports = __webpack_public_path__ + "assets/img/无内容.ad5ffa21.png";